import settings from 'settings'
import { useAppDispatch, useAppSelector } from 'app/state'
import { useResource } from 'app/state/resource'

import { User } from 'features/users'
import { addApps, myAppsResource, trackAppSelectedRequest, updateAppsFromList } from 'features/apps/state/appsSlice'
import { useDispatch } from 'react-redux'
import { useMutation, useQuery } from 'react-query'
import { patchApp, saveApp } from '../api/apps'
import { App, AppTypes } from '../types'
import { getApp } from '../api/appsQueries'
import { queryClient } from 'queryClient'

export function useApps() {
  const { data, isLoading, error } = useResource(myAppsResource)
  const userHasApps = !isLoading && (data?.length || 0) > 0
  const showFeaturedApps = settings.enableFeaturedApplications

  return {
    apps: data,
    isLoading,
    error,
    userHasApps,
    showFeaturedApps
  }
}

export function useTrackAppSelected() {
  const dispatch = useAppDispatch()
  const trackAppSelected = ({ user, appId, type }: { appId: string; user: User; type?: string }) =>
    dispatch(trackAppSelectedRequest({ user, appId, type }))
  return trackAppSelected
}

export function useBookmarkedApps() {
  const apps = useAppSelector((state) => state.apps.bookmarkedApps)
  return apps
}

export function useApp(id) {
  const { data, ...queryResponse } = useQuery<App, Error>(getApp(id))

  return { data, ...queryResponse }
}

export function usePatchAppMutation() {
  const dispatch = useDispatch()
  return useMutation({
    mutationFn: patchApp,
    onSuccess: (data) => {
      dispatch(updateAppsFromList(data))
    }
  })
}

export function useSaveApp() {
  const dispatch = useAppDispatch()
  const { data: apps } = useResource(myAppsResource)

  return useMutation({
    mutationFn: saveApp,
    onSuccess: (data) => {
      if (apps?.find((app) => app.id === data.id)) {
        dispatch(updateAppsFromList(data))
        queryClient.setQueryData(getApp(data.id).queryKey, data)
      } else {
        dispatch(addApps([...(apps as App[]), { ...data, type: AppTypes.Listed }]))
      }
    }
  })
}
